import { IconButton } from '@chakra-ui/react';
import { memo } from 'react';
import { CloseIcon } from 'ui-components/dist/CloseIcon';
import { PlusIcon } from 'ui-components/dist/PlusIcon';

import { ContentCard, ContentCardProps } from '../ContentCard';

export const ContentSearchPickerContentCard: React.FC<ContentCardProps> = memo(
  ({ contentData, isSelected = false, ...props }) => {
    return (
      <ContentCard
        contentData={contentData}
        FadeComponent={
          <IconButton
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            aria-label="Toggle Content"
            borderRadius="full"
            icon={
              isSelected ? <CloseIcon boxSize={4} /> : <PlusIcon boxSize={4} />
            }
          />
        }
        isSelected={isSelected}
        {...props}
      />
    );
  },
);
